<div class="summary-operation-container">
  <div
    class="close-modal"
    (click)="closeModal()"
    *ngIf="showXIcon"
  >
    <span>X</span>
  </div>
  <div class="box-container">
    <div class="box summary-operation-title">
      <ng-container *ngIf="showIcon" class="mb-2">
        <ng-container [ngSwitch]="icon" >
          <ng-template [ngSwitchCase]="'warning'">
            <svg width="40" height="36" viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.3125 35.75H35.6875C38.8958 35.75 40.8958 32.2708 39.2917 29.5L23.6042 2.39584C22 -0.37499 18 -0.37499 16.3958 2.39584L0.708332 29.5C-0.895835 32.2708 1.10416 35.75 4.3125 35.75ZM20 21.1667C18.8542 21.1667 17.9167 20.2292 17.9167 19.0833V14.9167C17.9167 13.7708 18.8542 12.8333 20 12.8333C21.1458 12.8333 22.0833 13.7708 22.0833 14.9167V19.0833C22.0833 20.2292 21.1458 21.1667 20 21.1667ZM22.0833 29.5H17.9167V25.3333H22.0833V29.5Z"
                fill="#FFB82E"/>
            </svg>
          </ng-template>
          <ng-template [ngSwitchCase]="'success'">
            <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22.4997 0.333008C10.5397 0.333008 0.833008 10.0397 0.833008 21.9997C0.833008 33.9597 10.5397 43.6663 22.4997 43.6663C34.4597 43.6663 44.1663 33.9597 44.1663 21.9997C44.1663 10.0397 34.4597 0.333008 22.4997 0.333008ZM16.628 31.2947L8.84967 23.5163C8.00467 22.6713 8.00467 21.3063 8.84967 20.4613C9.69467 19.6163 11.0597 19.6163 11.9047 20.4613L18.1663 26.7013L33.073 11.7947C33.918 10.9497 35.283 10.9497 36.128 11.7947C36.973 12.6397 36.973 14.0047 36.128 14.8497L19.683 31.2947C18.8597 32.1397 17.473 32.1397 16.628 31.2947Z"
                fill="#39A84A"/>
            </svg>
          </ng-template>
          <ng-template ngSwitchDefault>
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22.0002 0.333496C10.0185 0.333496 0.333496 10.0185 0.333496 22.0002C0.333496 33.9818 10.0185 43.6668 22.0002 43.6668C33.9818 43.6668 43.6668 33.9818 43.6668 22.0002C43.6668 10.0185 33.9818 0.333496 22.0002 0.333496ZM32.8335 29.7785L29.7785 32.8335L22.0002 25.0552L14.2218 32.8335L11.1668 29.7785L18.9452 22.0002L11.1668 14.2218L14.2218 11.1668L22.0002 18.9452L29.7785 11.1668L32.8335 14.2218L25.0552 22.0002L32.8335 29.7785Z"
                fill="#D22419"/>
            </svg>
          </ng-template>
        </ng-container>
      </ng-container>

      <div class="title-container" [ngClass]="titleStyle">
        {{title | translate}}
      </div>
    </div>
  </div>
  <div *ngIf="titleMsg" class="summary-operation-detail mt-4">
    <div class="amount p-2">
      <p
        class="mb-1 justify"
        [innerHTML]="titleMsg"
      ></p>
    </div>
  </div>

  <div class="btns-container mt-5">
    <ng-container *ngFor="let btn of buttonOptions">
      <button
        [class]="btn.class"
        (click)="emitEvent(btn.eventName)"
      >{{btn.label}}
      </button>
    </ng-container>
  </div>

</div>
